import 'regenerator-runtime/runtime'
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'

import React from 'react'
import ReactDOM from 'react-dom'

import { DarkTheme, LightTheme, StardustProvider } from '@myxplor/stardust'
import { FlagProvider, LocalStorageProvider } from '@unleash/proxy-client-react'

import * as Analytics from '~/analytics'

import { AuthProvider } from '~/contexts/AuthContext'
import { SessionProvider } from '~/contexts/SessionContext'
import config from '~/config'
import App from '~/pages/App'

const themes = {
  dark: DarkTheme,
  light: LightTheme,
}

const unleashConfig = {
  url: config.UNLEASH_URL,
  clientKey: config.UNLEASH_CLIENT_KEY || 'no-key',
  refreshInterval: 15,
  appName: config.UNLEASH_APP_NAME,
  storageProvider: new LocalStorageProvider(),
  context: {
    properties: {
      platform: 'web',
    },
  },
}

Analytics.initialise()
Analytics.initializeGoogleTagManager()

// Deal with New Relic being dumb
const nr = (window as any).newrelic
nr.addRelease('stagate-client', config.VERSION)

const Root = () => (
  <StardustProvider activeTheme="light" themes={themes}>
    <FlagProvider config={unleashConfig} startClient={Boolean(config.UNLEASH_CLIENT_KEY)}>
      <AuthProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </AuthProvider>
    </FlagProvider>
  </StardustProvider>
)

ReactDOM.render(<Root />, document.getElementById('root'))
